import { render, staticRenderFns } from "./SolutionDetails.vue?vue&type=template&id=a117173a&scoped=true&"
import script from "./SolutionDetails.vue?vue&type=script&lang=js&"
export * from "./SolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SolutionDetails.vue?vue&type=style&index=0&id=a117173a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a117173a",
  null
  
)

export default component.exports